<template>
	<div id="app">
		<LoadingScreen v-if="isLoading" />

		<router-view />

		<ModalAlert id="globalErrors" @close="clearGlobalErrors" :visible="true" v-if="globalErrors">
			<DynamicIcon icon="not" :classString="'alert-exclamation'"/>
			<p class="global-error-message" v-for="(error, i) in globalErrors.errors"	:key="i" >{{ error }}</p>
			<p class="global-error-tracking-code"	v-if="globalErrors.trackingCode" >Código de Rastreio: {{ globalErrors.trackingCode }}</p>
		</ModalAlert>
	</div>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "./components/commons/ModalAlert.vue"
import LoadingScreen from "./components/commons/LoadingScreen"
import { mapActions, mapGetters } from "vuex"

export default {
	name: "App",
	components: {
		DynamicIcon, 
		ModalAlert,
		LoadingScreen
	},
	computed: {
		...mapGetters("app", ["globalErrors", "isLoading"]),
	},
	methods: {
		...mapActions("app", ["clearGlobalErrors"]),
		getBrowser()
		{
			if(this.$browserDetect.isChrome) return "c"
			if(this.$browserDetect.isEdge) return "e"
			if(this.$browserDetect.isFirefox) return "f"
			if(this.$browserDetect.isIE) return "i"
			if(this.$browserDetect.isOpera) return "o"
			if(this.$browserDetect.isSafari) return "s"
			return null
		}
	},
	mounted() {
		setTimeout(() => {
			let browser = this.getBrowser()
			if(!browser) return
			const buorgElement = document.querySelector('#buorg div'); 
			if (buorgElement) {
				const spanElement = document.createElement("span");
				spanElement.className = "buorg-icon";
				buorgElement.insertBefore(spanElement, buorgElement.firstChild);
				spanElement.style.background = "no-repeat 0px center url(https://browser-update.org/img/small/"+browser+".png)";
			}
		}, 500);
	}
}
</script>

<style>
#app {
	font-family: 'optum-sans', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	background: #FFFFFF no-repeat padding-box;
	color: #5A5A5A;
}
.global-error-message {
font-family: optum-sans;
font-size: 16px;
font-weight: 400;
line-height: 24px;
letter-spacing: 0em;
text-align: center;

}

.buorg {
  color: #C40000 !important;
  font-weight: bold !important;
}

.buorg {
	position:absolute;
	position:fixed;
	z-index:111111; 
	width:100%; 
	top:0px; 
	left:0px; 
	border-bottom:1px solid #A29330; 
	text-align:center;  
	color:#fff8ea !important; 
	background-color: #C40000; 
	font: 18px Calibri,Helvetica,sans-serif; 
	box-shadow: 0 0 5px rgba(0,0,0,0.2);
	animation: buorgfly 1s ease-out 0s;
	padding: 9px;
	display: flex;
    justify-content: center;
    align-items: center; 
    border: 1px solid #ddd;
}

.buorg div {
	text-align:center;
	font-size: 1.2em;
	padding: 9px;
}
</style>
